import { GetterTree } from 'vuex';
import { EntityNamesState } from '@/store/modules/entityNames/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<EntityNamesState, RootState> = {
  entityNames: (state) => state.entityNames
};
